import {
  APP_GOOGLE_PLACES_API_KEY,
  APP_SEGMENT_WRITE_KEY,
  APP_SEGMENT_WRITE_KEY_ANDROID,
  APP_SEGMENT_WRITE_KEY_IOS,
  APP_STRIPE_PUBLISHABLE_KEY,
  GROWTHBOOK_API_KEY_PROD,
  GROWTHBOOK_API_KEY_SANDBOX,
  GROWTHBOOK_API_KEY_STG,
  MMKV_ENCRYPTION_KEY,
  SANDBOX_NAME,
  APP_ID as _APP_ID,
  AUTH0_CLIENT_ID_ALTO as _AUTH0_CLIENT_ID_ALTO,
  AUTH0_CLIENT_ID_ALTO_DEV as _AUTH0_CLIENT_ID_ALTO_DEV,
  AUTH0_CLIENT_ID_ALTO_STG as _AUTH0_CLIENT_ID_ALTO_STG,
  BACKEND_ENVIRONMENT as _BACKEND_ENVIRONMENT,
  NATIVE_URL_PREFIX as _NATIVE_URL_PREFIX,
  NODE_ENV as _NODE_ENV,
  WEB_VERSION as _WEB_VERSION,
  // eslint-disable-next-line import/no-unresolved
} from '@env';
import { getAuth0ClientID, getAuth0Domain } from './config/getAuth0Config';
import { getBaseURL } from './config/getBaseUrls';
import { getGrowthbookApiKey } from './config/getExperimentationConfig';
import { getScheduledDowntimeUrl } from './config/getScheduledDowntimeUrl';
import { isWebStaging } from './config/isWebStaging';

// for web, staging and sandboxes/demos use the same container image with
// BACKEND_ENVIRONMENT baked in as "sandbox", so distinguish that here.
//
// I'd like to also set the exported BACKEND_ENVIRONMENT from this for consistency, but not sure if that's a safe
// change.
const realBackend = isWebStaging({ backendEnv: _BACKEND_ENVIRONMENT }) ? 'staging' : _BACKEND_ENVIRONMENT;

export const { API_URL, API_WEBSOCKET_URL } =
  realBackend === 'sandbox'
    ? getBaseURL({ env: realBackend, sandboxName: SANDBOX_NAME })
    : getBaseURL({ env: realBackend });

export const BACKEND_ENVIRONMENT = _BACKEND_ENVIRONMENT;
export const SCHEDULED_DOWNTIME_URL = getScheduledDowntimeUrl(BACKEND_ENVIRONMENT);
export const GOOGLE_PLACES_API_KEY = APP_GOOGLE_PLACES_API_KEY;
export const PLAID_ENV = BACKEND_ENVIRONMENT === 'production' ? 'production' : 'sandbox';
export const SEGMENT_WRITE_KEY = APP_SEGMENT_WRITE_KEY;
export const SEGMENT_WRITE_KEY_IOS = APP_SEGMENT_WRITE_KEY_IOS;
export const SEGMENT_WRITE_KEY_ANDROID = APP_SEGMENT_WRITE_KEY_ANDROID;
export const STRIPE_PUBLISHABLE_KEY = APP_STRIPE_PUBLISHABLE_KEY;
export const getAuth0DomainForEnv = () => getAuth0Domain(BACKEND_ENVIRONMENT);

const auth0IDs = {
  fuzerx: {
    dev: _AUTH0_CLIENT_ID_ALTO_DEV,
    stg: _AUTH0_CLIENT_ID_ALTO_STG,
    prod: _AUTH0_CLIENT_ID_ALTO,
  },
};
export const getAuth0ClientIDForEnv = () => getAuth0ClientID(BACKEND_ENVIRONMENT, auth0IDs);
export const GROWTHBOOK_API_KEY = getGrowthbookApiKey({
  env: BACKEND_ENVIRONMENT,
  production: GROWTHBOOK_API_KEY_PROD,
  sandbox: GROWTHBOOK_API_KEY_SANDBOX,
  staging: GROWTHBOOK_API_KEY_STG,
});
export const NATIVE_URL_PREFIX = _NATIVE_URL_PREFIX;
export const NODE_ENV = _NODE_ENV;
export const WEB_VERSION = _WEB_VERSION;
export const APP_ID = _APP_ID || 'com.scriptdash.altopharmacy';
export const MMKV_STORAGE_ENCRYPTION_KEY = MMKV_ENCRYPTION_KEY;
